<ng-container *ngIf="!loading; else isLoading">
  <div class="gw-flex gw-w-full gw-flex-col gw-gap-2">
    <label
      *ngIf="label"
      class="gw-text-sm gw-font-semibold gw-text-white"
      [attr.for]="id"
    >
      {{ label | translate }}
    </label>

    <div
      class="gw-w-full gw-rounded-xl gw-border gw-border-white/10 gw-bg-[#1f1f1f] gw-transition-colors focus-within:gw-border-white/20"
    >
      <mat-form-field
        class="gw-w-full gatewee-select-dark"
        [appearance]="appearance"
        [floatLabel]="floatLabel"
      >
        <ng-container *ngIf="autocomplete; else selectMode">
          <mat-chip-list *ngIf="multiple && innerValue?.length">
            <mat-chip
              *ngFor="let v of innerValue"
              [selectable]="true"
              [removable]="!disabled"
              (removed)="removeSelected(v)"
            >
              {{ getLabel(v) | translate }}
              <mat-icon matChipRemove *ngIf="!disabled">cancel</mat-icon>
            </mat-chip>
          </mat-chip-list>

          <input
            type="text"
            matInput
            [placeholder]="placeholder"
            [formControl]="searchControl"
            [matAutocomplete]="auto"
            [disabled]="disabled"
            (blur)="onTouched()"
            class="gw-text-sm gw-text-white placeholder:gw-text-[#b8b8b8]"
          />

          <mat-autocomplete
            #auto="matAutocomplete"
            (optionSelected)="
              multiple
                ? toggleSelection($event.option.value)
                : selectControl.setValue($event.option.value)
            "
          >
            <mat-option
              *ngFor="let item of filteredItems | async"
              [value]="item.value"
              [disabled]="disabled"
            >
              <mat-checkbox
                *ngIf="multiple"
                [checked]="isSelected(item.value)"
                (click)="$event.stopPropagation()"
              ></mat-checkbox>
              {{ item.label | translate }}
            </mat-option>
          </mat-autocomplete>
        </ng-container>

        <ng-template #selectMode>
          <mat-select
            [id]="id"
            [placeholder]="placeholder"
            [multiple]="multiple"
            [formControl]="selectControl"
            [compareWith]="compareWith"
            class="gw-text-sm gw-text-white"
          >
            <mat-option *ngFor="let item of items" [value]="item.value">
              {{ item.label | translate }}
            </mat-option>
          </mat-select>
        </ng-template>
      </mat-form-field>
    </div>

    <error-message
      *ngIf="form && control"
      [form]="form"
      [controlName]="(ngControl.name ?? '') + ''"
      [customMessages]="customMessages"
    ></error-message>
  </div>
</ng-container>

<ng-template #isLoading>
  <gatewee-skeleton></gatewee-skeleton>
</ng-template>
